// The calm full-page "gone" screen shared by NotFound and LinkUnavailable (§4.10/AC3: missing and
// forbidden are indistinguishable, so both say as little as possible).
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Card, Icon } from "@grackle/ui";
import { ButtonLink } from "./form";
import { GrackleLogo } from "./ui";
import { useSession } from "../session";
import "./noaccess.css";

export function NoAccessShell({ icon, title, children }: { icon: string; title: string; children: ReactNode }) {
  const { user } = useSession();
  return (
    <div className="noaccess">
      <header className="noaccess__bar">
        <Link to="/" aria-label="Grackle home">
          <GrackleLogo />
        </Link>
        {user ? <span className="noaccess__user">{user.email}</span> : <ButtonLink to="/signin" variant="secondary">Sign in</ButtonLink>}
      </header>
      <main className="noaccess__body">
        <Card size="lg" className="noaccess__card">
          <Icon name={icon} size={28} />
          <h1>{title}</h1>
          {children}
        </Card>
      </main>
    </div>
  );
}
